import { Avatar, Box, Chip } from "@mui/material";
import { logoUrl } from "../../api/logo";
import {
  senderKey,
  type InvoiceSender,
  type SenderKey,
} from "../../logic/invoice-sender";

export type SenderTogglesProps = {
  /** One chip per sender, payees and accounts alike. */
  options: InvoiceSender[];
  value: SenderKey[];
  onChange: (next: SenderKey[]) => void;
};

export const SenderToggles = ({
  options,
  value,
  onChange,
}: SenderTogglesProps) => {
  if (options.length === 0) return null;

  const toggle = (key: SenderKey) => {
    if (value.includes(key)) {
      onChange(value.filter((v) => v !== key));
    } else {
      onChange([...value, key]);
    }
  };

  return (
    <Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap" }}>
      {options.map((sender) => {
        const key = senderKey(sender);
        const label = sender.entity ? sender.entity.name : sender.id;
        const selected = value.includes(key);
        return (
          <Chip
            key={key}
            size="small"
            label={label}
            avatar={
              sender.entity ? (
                <Avatar alt={label} src={logoUrl(sender.kind, sender.entity)} />
              ) : undefined
            }
            color={selected ? "primary" : "default"}
            variant={selected ? "filled" : "outlined"}
            onClick={() => toggle(key)}
            sx={{ opacity: selected ? 1 : 0.75 }}
          />
        );
      })}
    </Box>
  );
};
